'use client';

import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import { VerticalFeaturedCardSkeleton } from '../components/mobile_vertical_feature_card';
import { SearchNavBar } from '../components/search_navbar';

export default function Loading() {
    return (
        <>
            <Box sx={{ position: 'sticky', maxWidth: '1920px', top: 0, zIndex: 1000, margin: '0 auto' }}>
                <SearchNavBar />
            </Box>
            <Grid
                container
                sx={{
                    height: '94vh',
                    pt: '10px',
                    backgroundColor: '#1C1C34',
                    color: 'white',
                    margin: '0 auto',
                }}
            >
                <Grid item xs={12} md={6} sx={{ height: '99%', overflowY: 'hidden' }}>
                    <Skeleton variant='rectangular' width='100%' height='100%' />
                </Grid>
                <Grid item xs={12} md={6} sx={{ height: '100%', overflow: 'auto' }}>
                    <Box sx={{ padding: '0 8px 16px 16px' }}>
                        {Array.from(new Array(5)).map((_, index) => (
                            <VerticalFeaturedCardSkeleton key={index} />
                        ))}
                    </Box>
                </Grid>
            </Grid>
        </>
    );
}
